
document.addEventListener('submit', async function(event){
  const form = event.target;
  if(!form.matches('[data-add-to-cart]')) return;

  event.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  const originalText = button ? button.textContent : '';

  if(button){
    button.disabled = true;
    button.textContent = 'Agregando...';
  }

  try{
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: {'Accept':'application/json'}
    });

    if(!response.ok) throw new Error('Error');

    if(button) button.textContent = 'Agregado ✓';

    setTimeout(function(){
      if(button){
        button.disabled = false;
        button.textContent = originalText;
      }
    }, 1200);
  }catch(error){
    if(button){
      button.disabled = false;
      button.textContent = originalText;
    }
    form.submit();
  }
});
